// Add your language here
const LANGUAGES = [
  { name: 'English', shortCode: 'en', label: 'English', value: 'en' },
  { name: 'Norsk', shortCode: 'no', label: 'Norsk', value: 'no' }
  // { name: 'Ukrainian', shortCode: 'ua', label: 'Ukrainian', value: 'ua' }
]

export default LANGUAGES
